@let infos = display();
@if (infos) {
  @let inline = mode() === 'inline';
  <div class="field-group">
    <app-syncro-information
      [status]="infos.status"
      [title]="infos.title"
      [message]="message()!"
      [icon]="infos.icon"
      [requieredError]="hasRequiredError()"
    >
      @switch (state()) {
        @case ('gps-too-short') {
          @if (inline) {
            <button class="cta-black" (click)="openEditor.emit()">
              {{ 'common.edit' | translate }}
            </button>
          }
        }
        @case ('speed-warning') {
          <button class="cta-black stroke" (click)="openFaq()">
            FAQ
            <kin-icon [size]="16" name="external" />
          </button>
          @if (!inline && canEnterSyncMode()) {
            <button class="cta-primary" (click)="verify()">
              {{ 'syncro.verify' | translate }}
            </button>
          }
        }
        @case ('synced') {
          <button class="cta-black" (click)="edit()">{{ 'common.edit' | translate }}</button>
        }
        @case ('likely-synced') {
          <button class="cta-black stroke" (click)="mediaBlockService.validateAlignedSync()">
            {{ 'common.validate' | translate }}
          </button>
          @if (inline || canEnterSyncMode()) {
            <button class="cta-primary" (click)="verify()">
              {{ 'syncro.synchronize' | translate }}
            </button>
          }
        }
        @case ('not-synced') {
          @if (inline || canEnterSyncMode()) {
            <button class="cta-primary" (click)="verify()">
              {{ 'syncro.verify' | translate }}
            </button>
          }
        }
      }
    </app-syncro-information>

    @if (hasRequiredError()) {
      <p class="field-error">{{ 'common.required_field' | translate }}</p>
    }
  </div>
}

@if (showTips()) {
  <section class="tips">
    @for (tip of tips; track $index; let last = $last) {
      <div class="step">
        <kin-icon class="icon" [name]="tip.icon" />
        <div>
          <p>
            <span class="strong">{{ 'syncro.step' | translate: { step: $index + 1 } }}</span>
            {{ tip.text | translate }}
          </p>
          <p class="advice">{{ tip.advice | translate }}</p>
        </div>
        @if (!last) {
          <kin-icon name="arrow_right" />
        }
      </div>
    }
    <button
      class="cta-black"
      [disabled]="!mediaBlockService.syncMarkerCoordinate()"
      (click)="mediaBlockService.synchronize()"
    >
      {{ 'syncro.validate' | translate }}
    </button>
    <a class="cancel" (click)="cancelSyncMode()">{{
      'common.cancel' | translate | upperFirstLetter
    }}</a>
  </section>
}
